import React, { Fragment, useContext } from 'react'
import styled from 'styled-components/macro'
import { Flex, Block } from '../../basic/layout'
import { Context } from '../../../context'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/fontawesome-free-solid'

const Click = styled.button`
    top: 10px;
    right: 10px;
    cursor: pointer;
    border: none;
    position: absolute;
    &:hover {
        color: royalblue;
    }
`

export const Popup = () => {
    const [state, dispatch] = useContext(Context)
    document.onkeydown = function (evt) {
		if (evt.key === "Escape") {
			dispatch({type: 'SET_POPUP', payload: null})
		}
	}
	return(
		<Fragment>
			{(state && state.popup)
				&& <Flex position="fixed" top="0px" height="100vh" background="rgba(0,0,0,.5)" z="13">
					<Block className="overflowY" background="whitesmoke" width={`calc(${state.popup.popupWidth ? state.popup.popupWidth : '562px'} - 60px)`} maxHeight={`${state.popup.maxHeight? state.popup.maxHeight: "calc(100% - 100px)"}`} padding={`${state.popup.padding?state.popup.padding: "30px"}`} height={`${state.popup.height?state.popup.height: null}`}>
                        {state.popup.title && <Fragment>{state.popup.title}</Fragment>}
                        {state.popup.popupTitle && <Fragment>{state.popup.popupTitle}</Fragment>}
                        {state.popup.subTitle && <Fragment>{state.popup.subTitle}</Fragment>}
                        <Click onClick={() => dispatch({type: 'SET_POPUP', payload: null})}><FontAwesomeIcon icon={faTimes} /></Click>
                        {state.popup.info
                            && <Block margin="20px 0 0 0">
                                {state.popup.info}
                            </Block>
                        }
                    </Block>
				</Flex>
            }
		</Fragment>
	)
}